import React from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { Container } from "reactstrap"

//Import sections
import CarparkTicketList from "./CarparkTicketList"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

const CarparkTicketView = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Session Tickets | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs
            title="Session Tickets"
            breadcrumbItem="Session Tickets"
          />
          <CarparkTicketList />
        </Container>
      </div>
    </React.Fragment>
  )
}

CarparkTicketView.propTypes = {
  match: PropTypes.object,
}

export default withRouter(CarparkTicketView)
